/** Bandeja de productos propuestos desde la Pizarra — solo visible en el Centro de Control Admin.
 *  Aprobar define el costo oficial y recién entonces el producto entra al catálogo Soluarq. */
import { useEffect, useState } from 'react';
import api from '@/api/axios';
import { toast } from 'sonner';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';

export const BandejaProductos = () => {
  const [rows, setRows] = useState(null);
  const [costos, setCostos] = useState({});
  const load = () => api.get('/sa/pizarra/productos-propuestos')
    .then((r) => setRows((r.data.propuestos || []).filter((p) => p.estado === 'pendiente')))
    .catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const resolver = async (id, accion) => {
    try {
      await api.patch(`/sa/pizarra/productos-propuestos/${id}`, { accion, costo: Number(costos[id] || 0) });
      toast.success(accion === 'aprobar' ? 'Producto aprobado y agregado al catálogo ✅' : 'Propuesta rechazada');
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Error'); }
  };

  if (!rows || rows.length === 0) return null;
  return (
    <Card className="p-4 bg-[var(--surface)] border-amber-500/40 border" data-testid="bandeja-productos-card">
      <h3 className="text-sm font-black uppercase tracking-wider text-[var(--text)]">
        📦 Productos propuestos desde la Pizarra
        <span className="ml-2 text-[10px] font-black bg-amber-500 text-white rounded-full px-2 py-0.5" data-testid="bandeja-contador">{rows.length} pendiente(s)</span>
      </h3>
      <p className="text-[10px] text-[var(--text-muted)] mb-2">No entran al catálogo oficial hasta que los apruebes con su costo.</p>
      <div className="space-y-2">
        {rows.map((p) => (
          <div key={p.id} className="border border-[var(--border)] rounded-[10px] p-2.5" data-testid={`bandeja-item-${p.id}`}>
            <p className="text-xs font-black text-[var(--text)]">{p.descripcion} {p.codigo && <span className="text-[#7352B5]">· {p.codigo}</span>}</p>
            <p className="text-[10px] text-[var(--text-muted)]">
              {[p.tipo_material, p.color, p.precio_referencial ? `ref. Q${p.precio_referencial}` : '', p.observaciones].filter(Boolean).join(' · ') || 'Sin detalles'}
              {' · '}👤 {p.propuesto_por} · {String(p.created_at).slice(0, 10)}
            </p>
            <div className="flex gap-1.5 mt-1.5 items-center">
              <Input type="number" placeholder="Costo oficial Q" value={costos[p.id] ?? ''}
                onChange={(e) => setCostos({ ...costos, [p.id]: e.target.value })}
                className="h-8 text-xs w-32 bg-[var(--bg)]" data-testid={`bandeja-costo-${p.id}`} />
              <button onClick={() => resolver(p.id, 'aprobar')}
                className="h-8 px-3 rounded-lg bg-emerald-500/15 text-emerald-600 border border-emerald-500/40 text-[11px] font-black hover:bg-emerald-500/25"
                data-testid={`bandeja-aprobar-${p.id}`}>✓ Aprobar</button>
              <button onClick={() => resolver(p.id, 'rechazar')}
                className="h-8 px-3 rounded-lg bg-red-500/10 text-red-500 border border-red-500/30 text-[11px] font-black hover:bg-red-500/20"
                data-testid={`bandeja-rechazar-${p.id}`}>✕ Rechazar</button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
